import { render, staticRenderFns } from "./GiftCatalog.vue?vue&type=template&id=8a25335e"
import script from "./GiftCatalog.vue?vue&type=script&lang=js"
export * from "./GiftCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports